module.exports = __webpack_public_path__ + "static/media/printer.4ce2caa5.png";